import { map } from "rxjs";
import { apiService } from "../ApiService";

export const getNTPTime = () => {
  return apiService
    .get<{ time: string }>({
      path: "/v1/time",
    })
    .pipe(
      map((res) => {
        return new Date(res.time);
      }),
    );
};
